import { apiClient, throwApiError } from './apiClient';
import type { SimulationInsert, SimulationUpdate } from '@urbanmetrix/sdk';

export async function getSimulations(simulationSetId: string) {
  const response = await apiClient.api['simulation-sets']({ simulationSetId }).simulations.get();
  if (response.error) {
    throwApiError(response.error.value, response.error.status, true);
  }
  return response.data;
}

export async function getSimulation(simulationSetId: string, simulationId: string | number) {
  const response = await apiClient.api['simulation-sets']({ simulationSetId })
    .simulations({ simulationId: String(simulationId) })
    .get();
  if (response.error) {
    throwApiError(response.error.value, response.error.status, true);
  }
  return response.data;
}

export async function addSimulation(simulationSetId: string, simulation: SimulationInsert) {
  const response = await apiClient.api['simulation-sets']({ simulationSetId }).simulations.post(simulation);
  if (response.error) {
    throwApiError(response.error.value, response.error.status);
  }
  return response.data;
}

export async function updateSimulation(
  simulationSetId: string,
  simulationId: string | number,
  simulation: SimulationUpdate
) {
  const response = await apiClient.api['simulation-sets']({ simulationSetId })
    .simulations({ simulationId: String(simulationId) })
    .patch(simulation);
  if (response.error) {
    throwApiError(response.error.value, response.error.status);
  }
  return response.data;
}

export async function updateSimulationVisibility(
  simulationSetId: string,
  simulationId: string | number,
  isActive: boolean
) {
  const endpoint = apiClient.api['simulation-sets']({ simulationSetId }).simulations({
    simulationId: String(simulationId),
  }) as unknown as {
    visibility: {
      patch: (payload: { isActive: boolean }) => Promise<{
        data: Awaited<ReturnType<typeof getSimulation>>;
        error: { value: unknown; status: number } | null;
      }>;
    };
  };
  const response = await endpoint.visibility.patch({ isActive });
  if (response.error) throwApiError(response.error.value, response.error.status);
  return response.data;
}

export async function deleteSimulation(simulationSetId: string, simulationId: string | number) {
  const response = await apiClient.api['simulation-sets']({ simulationSetId })
    .simulations({ simulationId: String(simulationId) })
    .delete();
  if (response.error) {
    throwApiError(response.error.value, response.error.status);
  }
  return response.data;
}
